"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var seesignage_utils_1 = require("@seesignage/seesignage-utils");
var react_1 = __importStar(require("react"));
var MediaCarouselImage_1 = __importDefault(require("./MediaCarouselImage"));
var MediaCarouselVideo_1 = __importDefault(require("./MediaCarouselVideo"));
var MediaCarouselContent_1 = __importDefault(require("./MediaCarouselContent"));
var MediaCarouselComponent = function (_a) {
    var _b, _c;
    var mediaCarouselProps = _a.mediaCarouselProps, width = _a.width, height = _a.height;
    var carouselItems = mediaCarouselProps.carouselItems, interval = mediaCarouselProps.interval, objectFit = mediaCarouselProps.objectFit, videosMuted = mediaCarouselProps.videosMuted, background = mediaCarouselProps.background;
    var _d = (0, react_1.useState)(0), displayIndex = _d[0], setDisplayIndex = _d[1];
    var nextIndex = function () {
        if (displayIndex < carouselItems.length - 1) {
            setDisplayIndex(displayIndex + 1);
        }
        else {
            setDisplayIndex(0);
        }
    };
    (0, react_1.useEffect)(function () {
        // make sure that playback starts from the first index when carouselItems changes
        setDisplayIndex(0);
    }, [carouselItems]);
    (0, react_1.useEffect)(function () {
        var timer;
        var currentItem = carouselItems[displayIndex];
        if (currentItem &&
            ((0, seesignage_utils_1.isCarouselImageItemPlayer)(currentItem) || (0, seesignage_utils_1.isCarouselContentItemPlayer)(currentItem))) {
            timer = setTimeout(function () {
                nextIndex();
            }, interval);
        }
        return function () {
            if (timer) {
                clearTimeout(timer);
            }
        };
    }, [displayIndex, carouselItems]);
    var handleVideoOnEnded = function () {
        nextIndex();
    };
    var currentItem = carouselItems[displayIndex];
    if ((0, seesignage_utils_1.isCarouselContentItemPlayer)(currentItem)) {
        return (react_1.default.createElement(MediaCarouselContent_1.default, { content: currentItem.content, viewWidth: width, viewHeight: height, objectFit: objectFit, background: background }));
    }
    if ((0, seesignage_utils_1.isCarouselImageItemPlayer)(currentItem)) {
        return (react_1.default.createElement(MediaCarouselImage_1.default, { objectFit: objectFit, src: (_b = currentItem.fileMetadata) === null || _b === void 0 ? void 0 : _b.url, background: background }));
    }
    if ((0, seesignage_utils_1.isCarouselVideoItemPlayer)(currentItem)) {
        return (react_1.default.createElement(MediaCarouselVideo_1.default, { objectFit: objectFit, src: (_c = currentItem.fileMetadata) === null || _c === void 0 ? void 0 : _c.url, muted: videosMuted ? true : false, autoPlay: true, loop: carouselItems.length === 1, onEnded: handleVideoOnEnded, background: background }));
    }
    return react_1.default.createElement(react_1.Fragment, null);
};
exports.default = MediaCarouselComponent;
//# sourceMappingURL=MediaCarouselComponent.js.map